import { useMemo, useCallback, useLayoutEffect } from 'react'

// core
import { useSearch } from '_core/hooks/useSearch'

export const useSearchTabs = ({ tabs, param = 'tab', canBeBlank }) => {
  const { setSearchParam, getSearchParam } = useSearch()
  const tab = getSearchParam(param)

  const rawOnTabChange = useCallback(value => setSearchParam(param, value), [
    param,
  ])
  const onTabChange = useCallback((_, value) => rawOnTabChange(value), [
    rawOnTabChange,
  ])

  let value = useMemo(() => {
    const data = tabs.find(item => item.value === tab)
    return data?.value ?? (!canBeBlank ? tabs[0].value : null)
  }, [tabs, tab, canBeBlank])

  useLayoutEffect(() => {
    !canBeBlank && !tab && rawOnTabChange(value)
  }, [tab, value, rawOnTabChange])

  return {
    tab: value,
    onTabChange,
    rawOnTabChange,
  }
}
